:host {
  ::part(item-with-btn) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 0;
  }

  ::part(item-with-btn-seats) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 0;
  }

  ::part(inside-btn) {
    --button-max-width: 20px;
  }
}

.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: scroll;

  padding-top: calc(var(--spacer) * 2);

  .main-container {
    display: block;
  }

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  &.is-loading {
    .main-container {
      display: none;
    }

    .loading-container {
      display: flex;
    }
  }
}

.cards-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;

  margin-bottom: calc(var(--spacer) * 8);

  .licensing-card {
    position: relative;
    flex: 0.5;
    flex-basis: 584px;
    max-width: 584px;

    border-radius: 5px;
    border: solid 1px var(--chart-101-pressed-dividers);

    padding: calc(var(--spacer) * 3) calc(var(--spacer) * 4) calc(var(--spacer) * 11) calc(var(--spacer) * 3);
    margin-top: calc(var(--spacer) * 2);
    margin-right: calc(var(--spacer) * 2);

    #copyToClipboardCompanyHash {
      max-width: 526px;
    }

    #mdr-container {
      margin-top:  calc(var(--spacer) * 3);

      .content-text {
        padding-left: calc(var(--spacer) * 1.5);
      }
    }

    #mdr-container gz-labeled-content {
      --text-color-on-light-90: var(--grey-layout-400);

      height: 32px;
      margin-top: calc(var(--spacer) * 1.5);
      max-width: 500px;
    }

    .licensing-payment-plan,
    #aws-subscription-container,
    #partner-name,
    #partner-id,
    #partner-address,
    #partner-phone-number {
      max-width: 490px;
    }

    .card-title {
      text-transform: uppercase;
      font-family: var(--font-family);
      color: var(--chart-300-icon-buttons);
      margin-bottom: calc(var(--spacer) * 3.5);
    }

    gz-form-field {
      --label-font-family: var(--font-family);
    }

    gz-form-field + gz-form-field {
      margin-top: calc(var(--spacer) * 0.5);
    }

    .text-hint {
      font-size: var(--body-size-small);
      color: var(--body-text-arrows-400);
    }

    gz-button {
      margin-top: calc(var(--spacer));
    }

    .licensing-card-buttons-container {
      position: absolute;
      bottom: calc(var(--spacer) * 3);
      display: flex;
      max-width: 490px;
    }

    .licensing-card-buttons {
      flex-flow: column;
    }

    .licensing-card-button {
      min-width: 250px;
    }

    .licensing-card-iz {
      margin-top: var(--spacer);
    }
  }
}

#aws-subscription-container {
  display: flex;
  align-items: start;
  margin-top: var(--spacer);

  .label {
    min-width: 250px;
    font-size: var(--dialog-font-size);
    padding-top: var(--spacer);
    color: var(--body-text-arrows-400);

    &:after {
      content: ' :';
    }
  }

  .value {
    flex: auto;
    height: 32px;
    line-height: 1;

    padding: calc(var(--spacer) / 2) 0 calc(var(--spacer) / 2) calc(var(--spacer) * 1.5);

    user-select: none;
    display: inline-flex;
    justify-content: start;
    align-items: center;

    &.value-marketplace-link {
      flex: none;
    }

    &.value-pan-link {
      flex: none;
    }
  }
}

#license-usage-details-title {
  padding-bottom: calc(var(--spacer) * 2);
}

#license-usage-details-info-box-message {
  margin-left: -8px;
  max-width: 800px;
  margin-top: 14px;
}

.license-usage-details-content {
  flex-grow: 2;
  height: 100%;

  .licenses-grid {
    height: 100%;
  }

  gz-grid-view {
    min-height: 100%;
    align-items: stretch;

    gz-button {
      margin-right: var(--spacer);
    }
  }
}

#refresh-button-tooltip {
  width: auto;
  margin-bottom: var(--spacer);
  padding-right: 0;
}

#logout-notice-container {
  display: flex;
  border-radius: 5px;
  line-height: 21px;

  padding-bottom: calc(var(--spacer) * 2);
  color: var(--body-text-arrows-400);
  font-size: var(--body-size);
}

#logout-warning-icon {
  font-size: 20px;
}
